import { gql } from '@apollo/client';

export const LINK_I4_ACCOUNT = gql`
  mutation LinkI4Account($input: LinkI4AccountInput!) {
    linkI4Account(input: $input) {
      userI4LinkId
      societyCode
      societyId
      memberId
      memberIdent
      isValidated
      tokenExpiresAt
      createdDate
      modifiedDate
    }
  }
`;

export const LINK_ILRONLINE_ACCOUNT = gql`
  mutation LinkIlrOnlineAccount($input: LinkIlrOnlineAccountInput!) {
    linkIlrOnlineAccount(input: $input) {
      userI4LinkId
      societyCode
      societyId
      memberId
      memberIdent
      isValidated
      tokenExpiresAt
      createdDate
      modifiedDate
    }
  }
`;

export const UNLINK_I4_ACCOUNT = gql`
  mutation UnlinkI4Account($input: UnlinkI4AccountInput!) {
    unlinkI4Account(input: $input)
  }
`;
